<template>
  <component :is="c_layout">
    <router-view />
  </component>
</template>

<script>
export default {
  computed: {
    c_layout () {
      return this.$route.meta.layout ? this.$route.meta.layout : () => import('@/layouts/Default');
    },
  },
};
</script>
